import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "レイヤー 2",
  viewBox: "0 0 80 80"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g data-name=\"レイヤー 1\"><path fill=\"none\" d=\"M0 0h80v80H0z\" class=\"prefix__cls-1\"></path><path stroke=\"#c03\" stroke-linecap=\"round\" stroke-width=\"3\" d=\"m27.999 28 24 24\" class=\"prefix__cls-3\" data-name=\"パス 357\"></path><path stroke=\"#c03\" stroke-linecap=\"round\" stroke-width=\"3\" d=\"m51.999 28-24 24\" class=\"prefix__cls-3\" data-name=\"パス 358\"></path><circle cx=\"40\" cy=\"40\" r=\"38.5\" fill=\"none\" stroke=\"#c03\" stroke-width=\"3\" class=\"prefix__cls-2\"></circle></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }